"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
/**
 * getTickIconSvg:
 * Generates a data URL for an SVG tick icon with a customizable fill color.
 *
 * @param {string} color - The color to be used for the fill of the SVG tick icon.
 * @returns {string} A base64-encoded data URL representing the tick icon SVG, which can be used as a background image in CSS.
 *
 * The function creates an SVG string representing a tick (checkmark) icon, with the fill color dynamically set based on the input `color` parameter.
 * The SVG is then converted to a base64-encoded data URL that can be used in CSS as a background image.
 */
var getTickIconSvg = function (color) {
    var tickIconSvg = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"".concat(color, "\">\n      <path d=\"M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z\"/>\n    </svg>");
    var tickIconSvgBase64 = btoa(tickIconSvg);
    return "url(data:image/svg+xml;base64,".concat(tickIconSvgBase64, ")");
};
var makeTextStyling = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var variant = _a.variant;
    var _q = (0, react_1.useTheme)(), mvf = _q.mvf, breakpoints = _q.breakpoints;
    var lineHeight = mvf.lineHeight, palette = mvf.palette, fontSize = mvf.fontSize, typography = mvf.typography, spacing = mvf.spacing;
    var weight = typography.weight;
    return (0, react_1.css)(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ fontFamily: typography.fontFamily, letterSpacing: 'inherit' }, (variant === 'footer' && (_b = {
            fontSize: fontSize.tiny
        },
        _b[breakpoints.up('tabletSmall')] = {
            fontSize: fontSize.little,
        },
        _b.color = palette.text.secondaryTextColor,
        _b.textAlign = 'left',
        _b.lineHeight = lineHeight.small,
        _b))), (variant === 'header' && (_c = {
            fontSize: fontSize.small
        },
        _c[breakpoints.up('mobileMedium')] = {
            fontSize: fontSize.compact,
        },
        _c[breakpoints.up('tabletSmall')] = {
            fontSize: fontSize.medium,
        },
        _c[breakpoints.up('tabletMedium')] = {
            fontSize: fontSize.swoll,
        },
        _c[breakpoints.up('desktopSmall')] = {
            fontSize: fontSize.large,
        },
        _c[breakpoints.up('desktopMedium')] = {
            fontSize: fontSize.big,
        },
        _c.fontWeight = typography.weight.thick,
        _c))), (variant === 'summary' && (_d = {
            fontSize: fontSize.mini
        },
        _d[breakpoints.up('mobileMedium')] = {
            fontSize: fontSize.small,
        },
        _d[breakpoints.up('tabletSmall')] = {
            fontSize: fontSize.compact,
        },
        _d.lineHeight = lineHeight.small,
        _d.textAlign = 'left',
        _d.whiteSpace = 'pre-line',
        _d['& ol'] = {
            counterReset: 'li',
            listStyleType: 'none',
            paddingLeft: '0px',
            marginTop: '0px',
            '& li': {
                position: 'relative',
                padding: '20px 0 0 35px',
                '&::before': {
                    counterIncrement: 'li',
                    content: 'counter(li)',
                    border: "2px solid ".concat(palette.component.answerSelectedColor),
                    fontWeight: 'bold',
                    borderRadius: '50%',
                    position: 'absolute',
                    height: '20px',
                    width: '20px',
                    left: '0',
                    top: '18px',
                    textAlign: 'center',
                    color: palette.component.answerSelectedColor,
                },
            },
        },
        _d))), (variant === 'note' && (_e = {
            fontSize: fontSize.little
        },
        _e[breakpoints.up('tabletSmall')] = {
            fontSize: fontSize.mini,
        },
        _e[breakpoints.up('desktopSmall')] = {
            fontSize: fontSize.small,
        },
        _e.backgroundColor = palette.background.secondaryBackgroundColor,
        _e.color = palette.text.secondaryTextColor,
        _e.paddingLeft = spacing.medium,
        _e.paddingRight = spacing.medium,
        _e.paddingTop = spacing.tiny,
        _e.paddingBottom = spacing.tiny,
        _e.borderRadius = 4,
        _e))), (variant === 'question' && (_f = {
            fontSize: fontSize.medium
        },
        _f[breakpoints.up('mobileMedium')] = {
            fontSize: fontSize.hefty,
        },
        _f[breakpoints.up('tabletSmall')] = {
            fontSize: fontSize.swoll,
        },
        _f[breakpoints.up('tabletMedium')] = {
            fontSize: fontSize.large,
        },
        _f[breakpoints.up('desktopSmall')] = {
            fontSize: fontSize.big,
        },
        _f[breakpoints.up('desktopMedium')] = {
            fontSize: fontSize.huge,
        },
        _f.fontWeight = typography.weight.thick,
        _f))), ((variant === 'listItem' || variant === 'listItemWithSubtext') && __assign((_g = { wordBreak: 'break-word', fontSize: fontSize.mini }, _g[breakpoints.up('mobileMedium')] = {
        fontSize: fontSize.small,
    }, _g[breakpoints.up('tabletSmall')] = {
        fontSize: fontSize.compact,
    }, _g.lineHeight = lineHeight.small, _g.fontWeight = typography.weight.thick, _g), (variant === 'listItem' && {
        padding: spacing.tiny,
    })))), (variant === 'listItemSubtext' && (_h = {
            fontSize: fontSize.little
        },
        _h[breakpoints.up('tabletSmall')] = {
            fontSize: fontSize.mini,
        },
        _h[breakpoints.up('desktopMedium')] = {
            fontSize: fontSize.small,
        },
        _h))), (variant === 'tileItem' && (_j = {
            fontSize: fontSize.mini,
            wordBreak: 'break-word'
        },
        _j[breakpoints.up('mobileMedium')] = {
            fontSize: fontSize.small,
        },
        _j[breakpoints.up('tabletSmall')] = {
            fontSize: fontSize.compact,
        },
        _j[breakpoints.up('desktopMedium')] = {
            fontSize: fontSize.medium,
        },
        _j.textAlign = 'center',
        _j.margin = spacing.tiny,
        _j.lineHeight = lineHeight.small,
        _j.wordWrap = 'break-word',
        _j.fontWeight = typography.weight.thick,
        _j))), (variant === 'tileItemSubtext' && (_k = {
            fontSize: fontSize.tiny,
            wordBreak: 'break-word'
        },
        _k[breakpoints.up('mobileMedium')] = {
            fontSize: fontSize.little,
        },
        _k[breakpoints.up('tabletSmall')] = {
            fontSize: fontSize.mini,
        },
        _k[breakpoints.up('desktopMedium')] = {
            fontSize: fontSize.small,
        },
        _k.textAlign = 'center',
        _k.lineHeight = lineHeight.small,
        _k.wordWrap = 'break-word',
        _k.fontWeight = typography.weight.medium,
        _k))), (variant === 'text' && (_l = {
            fontSize: fontSize.mini
        },
        _l[breakpoints.up('mobileMedium')] = {
            fontSize: fontSize.small,
        },
        _l[breakpoints.up('tabletSmall')] = {
            fontSize: fontSize.compact,
        },
        _l.color = palette.text.secondaryTextColor,
        _l.lineHeight = lineHeight.small,
        _l))), (variant === 'contentWithList' && (_m = {
            fontSize: fontSize.little
        },
        _m[breakpoints.up('tabletSmall')] = {
            fontSize: fontSize.mini,
        },
        _m[breakpoints.up('desktopSmall')] = {
            fontSize: fontSize.small,
        },
        _m.backgroundColor = palette.background.secondaryBackgroundColor,
        _m.color = palette.text.secondaryTextColor,
        _m.paddingLeft = spacing.medium,
        _m.paddingRight = spacing.medium,
        _m.paddingTop = spacing.tiny,
        _m.paddingBottom = spacing.tiny,
        _m.borderRadius = 4,
        _m.textAlign = 'center',
        _m['& span, & ol, & ul'] = {
            backgroundColor: 'inherit',
            display: 'block',
        },
        _m['& ol, & ul'] = {
            paddingLeft: '0px',
            marginTop: '0px',
            listStylePosition: 'inside',
        },
        _m['& li'] = {
            margin: '0',
        },
        _m.margin = 0,
        _m.padding = 0,
        _m))), (variant === 'tickedList' && {
        color: palette.text.primaryTextColor,
        fontSize: fontSize.medium,
        fontWeight: weight.thick,
        '& li': (_o = {
                listStyleType: 'none',
                paddingLeft: 33,
                lineHeight: lineHeight.medium,
                fontWeight: weight.medium,
                fontSize: fontSize.compact
            },
            _o[breakpoints.up('tabletSmall')] = {
                fontSize: fontSize.medium,
                fontWeight: weight.thick,
            },
            _o.background = "".concat(getTickIconSvg(palette.component.answerSelectedColor), " no-repeat left 3px"),
            _o.backgroundSize = '20px 20px',
            _o),
        '& ul': (_p = {
                margin: '0 auto',
                width: 'fit-content'
            },
            _p[breakpoints.up('tabletSmall')] = {
                width: '100%',
            },
            _p.padding = 0,
            _p),
    })));
};
exports.default = makeTextStyling;
//# sourceMappingURL=makeTextStyling.js.map